import React from 'react'
import { withFirebase } from '../firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

const Logout = ({ firebase }) => {
    return (
        <a className="dropdown-item" href="#" onClick={firebase.doSignOut} >
            <FontAwesomeIcon className="mr-1" icon={faSignOutAlt} />
            Cerrar Sesión
        </a>
    );
}

export default withFirebase(Logout);